module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1dxi5"))).then(() => parcelRequire('5erN3'));